export const blackList_zhCN = {
  'cm.black.n01.lbl01': `手机号`,
  'cm.black.n01.lbl02': `移入开始日期`,
  'cm.black.n01.lbl03': `至`,
  'cm.black.n01.lbl04': `移入结束日期`,
  'cm.black.n01.btn05': `重置`,
  'cm.black.n01.btn06': `查询`,
  'cm.black.n02.btn01': `下载模板`,
  'cm.black.n02.btn02': `导入黑名单`,
  'cm.black.n02.btn03': `导出`,
  'cm.black.c01.lbl01': `会员名称`,
  'cm.black.c01.lbl02': `会员编号`,
  'cm.black.c01.lbl03': `手机号`,
  'cm.black.c01.lbl04': `移入时间`,
  'cm.black.c01.lbl05': `理由`,
  'cm.black.c01.lbl06': `操作`,
  'cm.black.c01.btn07': `删除`,
  'cm.black.d01.lbl01': `删除`,
  'cm.black.d01.lbl02': '确认要删除吗',
};
export const blackList_enUS = {
  'cm.black.n01.lbl01': `MP NUMBER`,
  'cm.black.n01.lbl02': `FROM`,
  'cm.black.n01.lbl03': `TO`,
  'cm.black.n01.lbl04': `END`,
  'cm.black.n01.btn05': `RESET`,
  'cm.black.n01.btn06': `SEARCH`,
  'cm.black.n02.btn01': `DOWNLOAD`,
  'cm.black.n02.btn02': `IMPORT`,
  'cm.black.n02.btn03': `EXPORT`,
  'cm.black.c01.lbl01': `MEMBER NAME`,
  'cm.black.c01.lbl02': `MEMBER ID`,
  'cm.black.c01.lbl03': `MP NUMBER`,
  'cm.black.c01.lbl04': `FROM`,
  'cm.black.c01.lbl05': `REASON(S)`,
  'cm.black.c01.lbl06': `ACTION`,
  'cm.black.c01.btn07': `DELETE`,
  'cm.black.d01.lbl01': `REMOVE`,
  'cm.black.d01.lbl02': 'Do you sure to remove this member from blacklist?',
};
